import React from "react";
import {
  RiDashboardLine,
  RiPieChartLine,
  RiTimeLine,
  RiFireLine,
  RiStockLine,
  RiFileList3Line,
  RiBarChartLine,
  RiMore2Fill,
  RiUserSettingsLine,
  RiUserLine,
  RiLockLine,
  RiWallet3Line,
  RiShoppingBag3Line,
  RiCalendarScheduleLine,
  RiCalendarEventLine,
  RiCalendarCheckLine,
  RiReceiptLine,
  RiTeamLine,
} from "react-icons/ri";
import logo from "../images/logo.png";
import { useNavigate } from "react-router-dom";
import NavItem from "./NavItem";
import SuperMarcketMenu from "./SuperMarcketMenu";
import RestaurantMenu from "./RestaurantMenu";

const Sidebar = ({ onHide, page }) => {
  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo"));
  const name = adminInfo?.name;
  const userTypeName = adminInfo?.userTypeName;
  const vansale = adminInfo?.vansale;
  const permission = adminInfo?.permission;
  const userType = sessionStorage.getItem("userType");
  const businessType = adminInfo?.businessType;
  const allowedPageIds = permission?.map((p) => p.submenuPageId) || [];
  const UserType = parseInt(userType)

  const navigate = useNavigate();


  return (
    <div className="w-80 overflow-y-auto h-[100dvh] bg-gradient-to-b from-gray-50 to-white border-r border-gray-200 flex flex-col">
      {/* Brand/Logo */}
      <div className="p-6 pb-2">
        <h1 className="text-2xl font-QBold text-gray-800 flex justify-between items-center">
          <span className="w-[100px]">
            <img className="w-full" src={logo} alt="" />
          </span>

          <span onClick={onHide}>
            <i className="ri-close-line"></i>
          </span>
        </h1>
      </div>

      {/* Navigation Items */}
      <nav className="flex-1 px-4 py-6 border-t border-gray-200">
        {/* User Profile Section */}
        <div className="flex items-center gap-3 p-3 mb-6 rounded-lg bg-gray-50">
          <div className="relative">
            <span className="text-[30px] text-gray-500">
              <RiUserSettingsLine />
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-QSemiBold text-gray-900 truncate">
              {name}
            </h4>
            <p className="text-xs font-QMedium text-gray-500 truncate">
              {userTypeName}
            </p>
          </div>
          <button className="text-gray-400 hover:text-gray-600">
            <RiMore2Fill className="w-4 h-4" />
          </button>
        </div>

        {/* Navigation Items */}
        <ul className="space-y-1 h-[500px] mb-16 overflow-y-auto ">
          {/* Check userType for full access */}
          {[3, 4, 5].includes(UserType) && (
           <>
              {businessType === 1 && (

                <SuperMarcketMenu page={page}/>
              
              )}

              {businessType === 2 && (
              <RestaurantMenu page={page}/>
                
              )}
            </>
          )}
        </ul>
      </nav>

     
    </div>
  );
};

// const NavItem = ({
//   icon,
//   title,
//   path,
//   navigateTo,
//   active = false,
//   show = true,
// }) => {
//   if (!show) return null;
//   return (
//     <li onClick={() => navigateTo(path)} className="font-QSemiBold">
//       <span
//         className={`flex items-center p-3 rounded-lg transition-all duration-200 ${
//           active
//             ? "bg-blue-50 text-indigo-600 font-medium"
//             : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
//         }`}
//       >
//         <span
//           className={`text-lg mr-3 ${
//             active ? "text-indigo-600" : "text-gray-500"
//           }`}
//         >
//           {icon}
//         </span>
//         <span>{title}</span>
//         {active && (
//           <span className="ml-auto w-1 h-6 bg-indigo-600 rounded-full"></span>
//         )}
//       </span>
//     </li>
//   );
// };

export default Sidebar;
